import {deliveryTypes} from 'app/constant'
import {DraftOrderState} from '../../models/DraftOrder'
import {calculateSubtotalPrice, calculateTotalPrice} from './helper'
import * as model from 'app/features/orders/models'
import {sellingPrice} from '../../helper'
import find from 'lodash/find'
import reject from 'lodash/reject'

export const getDraftOrder = () => async (dispatch: any, getState: any) => {
  const state: any = getState()
  const {order} = state.orders.draft
  return order
}

export const removeCustomer = (state: DraftOrderState) => {
  state.order.customerId = null
  state.order.shippingAddressId = null
  state.order.billingAddressId = null
  state.order.paymentMethodId = null
  state.customer = null
  state.order.isFreeShipping = false
  resetShippingTaxDiscount(state)
}

export const resetPaymentState = (state: DraftOrderState) => {
  state.customer.billingAddress = null
  state.order.billingAddressId = null
  state.order.paymentMethodId = null
  state.customer.paymentMethod = null
}

export const resetShippingTaxDiscount = (state: DraftOrderState) => {
  resetShippingTax(state)
  state.order.totalDiscounts = 0
  state.order.discountCodeId = undefined
  state.order.wineClubDiscounts = 0
  state.order.wineClubDiscountCodeId = undefined
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const resetShippingTax = (state: DraftOrderState) => {
  state.order.shippingPrice = 0
  state.order.shippingRate = null
  state.order.shippingRateId = undefined
  state.order.totalTax = 0
  state.order.isCompliant = false
  state.errors = []
  state.isDirty = true
}

export const resetShippingDiscount = (state: DraftOrderState) => {
  state.order.shippingPrice = state.order.shippingRate?.originalPrice
  state.order.shippingRate.originalPrice = state.order.shippingPrice
  state.order.isCompliant = false
  state.isDirty = true
}

export const setDraftOrderId = (state: DraftOrderState, action: any) => {
  state.order.id = action.payload
  state.isDirty = false
  state.isEditMode = true
}

export const setOrderDeliveryMethod = (state: DraftOrderState, action: any) => {
  state.order.orderDeliveryMethod = action.payload
  state.isDirty = true
  state.order.totalTax = 0
  state.order.isCompliant = false

  if (action.payload === deliveryTypes.pickup) {
    state.order.shippingPrice = 0
    state.order.shippingRateId = null
    state.order.shippingRate = null
    state.order.shippingAddressId = null
    state.customer.shippingAddress = null
    state.order.totalPrice = calculateTotalPrice(state.order)
  }

  if (action.payload === deliveryTypes.ship && !state.customer.shippingAddress) {
    state.customer.shippingAddress = state.customer?.billingAddress
    state.order.shippingAddressId = state.customer?.billingAddress?.id
  } else if (action.payload === deliveryTypes.ship && state.customer.shippingAddress) {
    state.order.shippingAddressId = state.customer?.shippingAddress?.id
  }
}

export const setShippingRate = (state: DraftOrderState, action: any) => {
  state.isDirty = true
  state.order.shippingRate = action.payload
  state.order.shippingRateId = action.payload.id
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const updateShippingPrice = (state: DraftOrderState, action: any) => {
  if (state.order.shippingRate && state.order.shippingRate.id) {
    const price = parseFloat(action.payload.price)
    state.order.shippingRate.price = price
    state.order.shippingPrice = price
    state.order.shippingRateId = action.payload.id
    state.order.totalPrice = calculateTotalPrice(state.order)
  }
}

export const setShippingComplianceAndTax = (state: DraftOrderState, action: any) => {
  const {totalTax, isCompliant, crv} = action.payload
  state.order.totalTax = totalTax
  state.order.isCompliant = isCompliant
  state.order.totalPrice = calculateTotalPrice(state.order)
  state.order.salesTax = parseFloat(totalTax) - parseFloat(crv)
  state.order.crv = parseFloat(crv)
  state.isDirty = true
}

export const addOrderItems = (state: DraftOrderState, action: any) => {
  const items: model.DraftOrderItem[] = action.payload.map((item: any) => {
    const price = sellingPrice(item)
    return {
      product: item.product,
      productId: item.productId,
      variantId: item.id,
      variant: item.name,
      available: item.available,
      quantity: 1,
      price: item.price,
      discountPrice: item.discountPrice,
      totalPrice: price * 1,
      shipAvailableForAdminPortal: item.shipAvailableForAdminPortal,
      pickupAvailableForAdminPortal: item.pickupAvailableForAdminPortal,
    }
  })
  state.order.items = [...state.order.items, ...items]
  state.order.subtotalPrice = calculateSubtotalPrice(state.order.items)
  resetShippingTaxDiscount(state)
  state.order.totalPrice = calculateTotalPrice(state.order)
  state.validateWineClubDiscount = true
}

export const setQuantity = (state: DraftOrderState, action: any) => {
  const order = {...state.order, items: [...state.order.items]}
  const item = find(order.items, {variantId: action.payload.variantId})
  if (item) {
    const price = sellingPrice(item)
    item.quantity = parseInt(action.payload.quantity || 0)
    item.totalPrice = price * item.quantity
  }
  state.order = order
  state.order.subtotalPrice = calculateSubtotalPrice(state.order.items)
  resetShippingTaxDiscount(state)
  state.order.totalPrice = calculateTotalPrice(state.order)
  state.validateWineClubDiscount = true
}

export const removeOrderItem = (state: DraftOrderState, action: any) => {
  const {id, variantId} = action.payload
  state.order.items = reject(state.order.items, {variantId})
  state.order.subtotalPrice = calculateSubtotalPrice(state.order.items)
  resetShippingTaxDiscount(state)
  state.validateWineClubDiscount = true
  if (id) {
    state.order.deletedItems = [...state.order.deletedItems, id]
  }
}

export const setCustomer = (state: DraftOrderState, action: any) => {
  if (state.order.customerId !== action.payload.id) {
    state.order.shippingAddressId = null
    state.order.billingAddressId = null
    state.order.paymentMethodId = null
    resetShippingTax(state)
    state.order.totalPrice = calculateTotalPrice(state.order)
  }
  state.order.customerId = action.payload.id
  state.customer = action.payload
  state.validateWineClubDiscount = true

  if (action.payload.defaultAddress?.id) {
    state.customer.shippingAddress = action.payload.defaultAddress
    state.customer.billingAddress = action.payload.defaultAddress
    state.order.shippingAddressId = action.payload.defaultAddress?.id
    state.order.billingAddressId = action.payload.defaultAddress?.id
  }
  setStatePaymentMethod(state, action.payload.paymentMethod)
  if (state.order.orderDeliveryMethod === deliveryTypes.pickup) {
    state.customer.shippingAddress = null
    state.order.shippingAddressId = null
  }
}

export const setFetchedAddress = (state: DraftOrderState, action: any) => {
  const {billingAddress, shippingAddress, paymentMethod} = action.payload
  state.customer = {
    ...state.customer,
    billingAddress,
    shippingAddress,
    paymentMethod,
  }
}

export const setChangeShippingAddress = (state: DraftOrderState, action: any) => {
  state.customer = {
    ...state.customer,
    shippingAddress: action.payload,
  }
  state.order.shippingAddressId = action.payload.id
  resetShippingTax(state)
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const setChangeBillingAddress = (state: DraftOrderState, action: any) => {
  state.customer = {
    ...state.customer,
    billingAddress: action.payload,
  }
  state.order.billingAddressId = action.payload.id
  resetShippingTax(state)
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const setDiscount = (state: DraftOrderState, action: any) => {
  const {discountAmount, id} = action.payload
  state.order.totalDiscounts = parseFloat(discountAmount || 0)
  state.order.discountCodeId = id
  state.order.totalTax = 0
  state.order.isCompliant = false
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const setWineClubDiscount = (state: DraftOrderState, action: any) => {
  const {discountAmount} = action.payload
  state.order.wineClubDiscounts = parseFloat(discountAmount || 0)
  if (parseFloat(discountAmount) > 0) {
    state.order.totalDiscounts = 0
    state.order.discountCodeId = undefined
    state.isDirty = true
  }
  state.order.totalTax = 0
  state.order.isCompliant = false
  state.order.totalPrice = calculateTotalPrice(state.order)
  state.validateWineClubDiscount = false
}

export const setPaymentMethodId = (state: DraftOrderState, action: any) => {
  state.order.paymentMethodId = action.payload
  state.isDirty = true
}

export const setFreeShipping = (state: DraftOrderState, action: any) => {
  state.order.isFreeShipping = action.payload
  if (action.payload) {
    state.order.shippingPrice = 0
    state.order.subtotalPrice = calculateSubtotalPrice(state.order.items)
    state.order.totalPrice = calculateTotalPrice(state.order)
  }
}

export const setStatePaymentMethod = (state: DraftOrderState, payload: any) => {
  if (payload && payload.id) {
    const {address, id} = payload
    if (address && address.id) {
      state.customer.billingAddress = address
      state.order.billingAddressId = address.id
    }
    state.order.paymentMethodId = id
    state.customer.paymentMethod = payload
  }
}

export const setViewDiscounts = (state: DraftOrderState, action: any) => {
  state.viewDiscounts = action.payload
  state.discounts = action.payload
}

export const setIsEditMode = (state: DraftOrderState, action: any) => {
  state.isEditMode = action.payload
}

export const setValid = (state: DraftOrderState, action: any) => {
  state.isValid = action.payload
}

export const setErrors = (state: DraftOrderState, action: any) => {
  state.errors = action.payload
}

export const setOrderNote = (state: DraftOrderState, action: any) => {
  state.order.note = action.payload
}

export const setDirty = (state: DraftOrderState, action: any) => {
  state.isDirty = action.payload
}

export const setDraftOrder = (state: DraftOrderState, action: any) => {
  state.order = action.payload
}

export const setDiscounts = (state: DraftOrderState, action: any) => {
  state.discounts = action.payload
}

export const setPaymentType = (state: DraftOrderState, action: any) => {
  state.order.paymentType = action.payload
}

export const setIsAutoDiscountRemoved = (state: DraftOrderState, action: any) => {
  state.order.isAutoDiscountRemoved = action.payload
}
export const setIsTaxRemoved = (state: DraftOrderState, action: any) => {
  state.order.isTaxRemoved = action.payload
}
